module.exports = __webpack_public_path__ + "static/media/2001-Graduation.536937c4.mov";